import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Pencil, Trash } from "lucide-react";

import CustomDropdown from "@/components/desktop/list/dropdown/CustomDropdown";
import CustomFetching from "@/components/desktop/fetching/CustomFetching";
import CustomBadge from "@/components/desktop/badge/CustomBadge";

export function useCategoryColumns({ tableState, isLoadingSave, selected, setSelected, setShowDelete, canEdit, canDelete }) {
	const navigate = useNavigate();

	return useMemo(
		() => [
			{
				Header: "#",
				accessor: "",
				disableSortBy: true,
				width: "5%",
				Cell: ({ row }) => {
					return <span>{(tableState.page - 1) * tableState.per_page + row.index + 1}</span>;
				},
			},
			{
				Header: "Nombre",
				accessor: "name",
				width: "20%",
				disableSortBy: true,
				Cell: ({ value }) => {
					return <span>{value}</span>;
				},
			},
			{
				Header: "Bodegas",
				accessor: "estates_names",
				disableSortBy: true,
				width: "50%",
				Cell: ({ value }) => {
					if (!value) return <span>-</span>;

					const items = value
						.split(",")
						.map((item) => item.trim())
						.filter(Boolean);

					return (
						<div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
							{items.map((item, index) => (
								<CustomBadge key={index} variant="neutral" size="sm">
									{item}
								</CustomBadge>
							))}
						</div>
					);
				},
			},
			{
				Header: "Acción",
				disableSortBy: true,
				accessor: "slug",
				width: "10%",
				Cell: ({ value, row }) => {
					const actions = [];
					if (canEdit) {
						actions.push({
							label: "Editar",
							action: () => navigate("/configuracion/categorias/editar/" + value),
							icon: Pencil,
						});
					}
					if (canDelete) {
						actions.push({
							label: "Eliminar",
							action: () => {
								setSelected(row.original.id);
								setShowDelete(true);
							},
							icon: Trash,
							danger: true,
						});
					}
					if (actions.length === 0) return null;
					return isLoadingSave && selected === row.original.id ? (
						<CustomFetching size={20} />
					) : (
						<CustomDropdown title="Acciones" items={actions} align="right" />
					);
				},
			},
		],
		[tableState, isLoadingSave, selected, setSelected, setShowDelete, canEdit, canDelete, navigate],
	);
}
